module.exports = __webpack_public_path__ + "img/icon_left_out.acd17466.svg";